import { ComponentContainer, SectionSeparator } from '@styles/layout';
import { GenericComponent } from '@model/content';
import { TripTypes } from '@model/common';
import { LinkListGroup } from '@components/common/link-list';

export const DestinationListContainer = ({ path, tripType, data }: GenericComponent) => {
  if (!path || !data) return null;
  const tripTypeValue = tripType || TripTypes.ALL;

  return (
    <ComponentContainer>
      <LinkListGroup
        tripType={tripTypeValue}
        tripTypeTours={data.tripTypeTours}
        images={data.listImages}
        heading={'trip-type-landing__tour-destinations--title'}
      />
      <SectionSeparator />
    </ComponentContainer>
  );
};
